<template>
  <div class="enriched-radio">
    <fieldset>
      <legend v-if="props.label">{{ props.label }}</legend>
      <PflegeRadio
        v-model="modelValue"
        :error-message="errorMessage"
        :has-error="hasError"
        :has-success="hasSuccess"
        :options="generatedOptions"
        :required="required"
        @blur="$emit('blur', $event)"
        @update:model-value="$emit('input', $event)"
      />
    </fieldset>
  </div>
</template>

<script setup>
import { computed } from 'vue'

defineEmits(['input', 'blur'])
const props = defineProps({
  name: {
    type: String,
    required: false,
    default: null
  },
  type: {
    type: String,
    required: false,
    default: null
  },
  required: {
    type: Boolean,
    required: false,
    default: true
  },
  hasSuccess: {
    type: Boolean,
    required: false,
    default: false
  },
  hasError: {
    type: Boolean,
    required: false,
    default: false
  },
  errorMessage: {
    type: String,
    required: false,
    default: null
  },
  values: {
    type: Array,
    required: false,
    default: null
  },
  label: {
    type: String,
    required: false,
    default: null
  }
})

const modelValue = defineModel({ type: [String, Number, Boolean] })

const generatedOptions = computed(() => {
  if (!props.values && (props.type === 'anrede' || props.type === 'dritte_anrede')) {
    return [
      {
        label: 'Herr',
        value: 'Herr'
      },
      {
        label: 'Frau',
        value: 'Frau'
      }
    ]
  } else {
    return props.values
  }
})
</script>

<style scoped>
.enriched-radio fieldset {
  border: none;
  padding: 0;
  margin: 0;
}

.enriched-radio fieldset legend {
  padding-left: 0;
  padding-bottom: 0.25rem;
  font-size: 1em;
}
</style>
